import { Button, DataGridRef } from '@cimplico/components';
import { useRef, useState } from 'react';
import { useIsActiveSubscription } from '../../../../hooks/use-is-active-subscription';
import { useIsFirmRole } from '../../../../hooks/use-is-firm-role';
import { User, UserRoleEnum } from '../../../../types/user';
import SecondaryPageActions from '../../../../components/secondary-page-actions/SecondaryPageActions';
import RemoveUsersConfirmDialog from '../../../users/RemoveUsersConfirmDialog';
import UserPrimaryActions from '../../../users/UserPrimaryActions';
import UserRoleEditDialog from '../../../users/UserRoleEditDialog';
import UsersTable from '../../../users/UsersTable';
import FirmUsersSidePanel from './FirmUsersSidePanel';

function FirmUsersContainer(): JSX.Element {
    const { isAdmin } = useIsFirmRole();

    const tableRef = useRef<DataGridRef | null>(null);

    const [search, setSearch] = useState('');
    const [sort, setSort] = useState('');
    const [filter, setFilter] = useState('');
    const [selectedUsers, setSelectedUsers] = useState<User[]>([]);
    const [action, setAction] = useState<string | undefined>();

    const activeSubscription = useIsActiveSubscription();
    const canUpdateUsers = selectedUsers.filter((u) => u.role !== UserRoleEnum.ADMIN);

    function resetTable(): void {
        setSelectedUsers([]);
        setAction(undefined);
        tableRef?.current?.clear();
    }

    return (
        <>
            <UserRoleEditDialog
                users={selectedUsers}
                isOpen={action === 'EDIT_ROLE'}
                onClose={(): void => setAction(undefined)}
                onUpdate={resetTable}
            />
            <RemoveUsersConfirmDialog
                userIds={selectedUsers.map((u) => u.id)}
                isOpen={action === 'REMOVE_USERS'}
                onClose={(): void => setAction(undefined)}
                onRemove={resetTable}
            />

            <div className="flex flex-col lg:flex-row gap-8">
                <div className="flex flex-col gap-y-2 grow">
                    {selectedUsers.length > 0 && isAdmin && (
                        <div className="ml-auto">
                            <SecondaryPageActions>
                                <Button
                                    type="secondary"
                                    label={`Edit Role (${canUpdateUsers.length})`}
                                    size="xs"
                                    onClick={(): void => setAction('EDIT_ROLE')}
                                    disabled={!activeSubscription}
                                />
                                <Button
                                    type="danger"
                                    label={`Remove from Firm (${canUpdateUsers.length})`}
                                    size="xs"
                                    onClick={(): void => setAction('REMOVE_USERS')}
                                    disabled={!activeSubscription}
                                />
                            </SecondaryPageActions>
                        </div>
                    )}
                    {selectedUsers.length === 0 && (
                        <UserPrimaryActions onFilterChange={setFilter} onSearchChange={setSearch} onSortChange={setSort} />
                    )}
                    <UsersTable
                        tableRef={tableRef}
                        search={search}
                        sort={sort}
                        filter={filter}
                        onSelect={setSelectedUsers}
                        isSelectable={isAdmin}
                    />
                </div>
                <FirmUsersSidePanel />
            </div>
        </>
    );
}

export default FirmUsersContainer;
